export default "__VITE_ASSET__f9e8935a__"